import React from 'react';
import styled from 'styled-components';
import { pink } from '@zocdoc/branding/colors';

import { Icon } from './_base';

const RapidRegistrationSVG = styled(Icon).attrs({ viewBox: '0 0 54 61.9' })`
    width: 0.8723747981em;
`;

export const RapidRegistration = ({ color = pink, ...props }) => (
    <RapidRegistrationSVG
        data-test="icon-rapid-registration"
        {...props}
    >
        <g fill={color}>
            <path d="M54 20.9V13h-9V0H9v13H0v7.9c0 .7 0 4.5 2.5 7.2 1.1 1.1 3 2.5 6.2 2.5H9V35c0 5.5 4.8 10 10.1 10H24v12h-9v4.9h23V57h-9V45h5.8C40.2 45 45 40.5 45 35v-4.4h.2c3.2 0 5.2-1.3 6.2-2.5 2.6-2.7 2.6-6.4 2.6-7.2zM9 25.2h-.2c-1.6 0-2.1-.6-2.3-.8-.9-1-1.1-2.7-1-3.3V18H9v7.2zM40 35c0 2.5-2.8 5-5.2 5H19.1c-2.4 0-5.1-2.5-5.1-5V5h26v30zm7.6-10.6c-.2.2-.8.8-2.3.8H45V18h3.6v3.1c0 .6-.1 2.4-1 3.3z" />
            <path d="M36 12.1L18 12v5h18zM18 19h12v5H18z" />
        </g>
        <clipPath>
            <path d="M85.6 118.4l-4.4 4.4-4.4-4.4-1.1 1.1 4.4 4.4-4.4 4.4 1.1 1.1 4.4-4.4 4.4 4.4 1.1-1.1-4.4-4.4 4.4-4.4z" />
        </clipPath>
    </RapidRegistrationSVG>
);

const SchedulingHeroSVG = styled(Icon).attrs({ viewBox: '0 0 54 61.9' })`
    width: 0.8723747981em;
`;

export const SchedulingHero = ({ color = pink, ...props }) => (
    <SchedulingHeroSVG
        data-test="icon-scheduling-hero"
        {...props}
    >
        <g fill={color}>
            <path d="M54 20.9V13h-9V0H9v13H0v7.9c0 .7 0 4.5 2.5 7.2 1.1 1.1 3 2.5 6.2 2.5H9V35c0 5.5 4.8 10 10.1 10H24v12h-9v4.9h23V57h-9V45h5.8C40.2 45 45 40.5 45 35v-4.4h.2c3.2 0 5.2-1.3 6.2-2.5 2.6-2.7 2.6-6.4 2.6-7.2zM9 25.2h-.2c-1.6 0-2.1-.6-2.3-.8-.9-1-1.1-2.7-1-3.3V18H9v7.2zM40 35c0 2.5-2.8 5-5.2 5H19.1c-2.4 0-5.1-2.5-5.1-5V5h26v30zm7.6-10.6c-.2.2-.8.8-2.3.8H45V18h3.6v3.1c0 .6-.1 2.4-1 3.3z" />
            <path d="M36.2 13.2l-3-2.7L23 22v-4h-4v9h4.7z" />
        </g>
        <clipPath>
            <path d="M-137.4 118.4l-4.4 4.4-4.4-4.4-1.1 1.1 4.4 4.4-4.4 4.4 1.1 1.1 4.4-4.4 4.4 4.4 1.1-1.1-4.4-4.4 4.4-4.4z" />
        </clipPath>
    </SchedulingHeroSVG>
);

const SeeYouAgainSVG = styled(Icon).attrs({ viewBox: '0 0 54 61.9' })`
    width: 0.8723747981em;
`;

export const SeeYouAgain = ({ color = pink, ...props }) => (
    <SeeYouAgainSVG
        data-test="icon-see-you-again"
        {...props}
    >
        <g fill={color}>
            <path d="M54 20.9V13h-9V0H9v13H0v7.9c0 .7 0 4.5 2.5 7.2 1.1 1.1 3 2.5 6.2 2.5H9V35c0 5.5 4.8 10 10.1 10H24v12h-9v4.9h23V57h-9V45h5.8C40.2 45 45 40.5 45 35v-4.4h.2c3.2 0 5.2-1.3 6.2-2.5 2.6-2.7 2.6-6.4 2.6-7.2zM9 25.2h-.2c-1.6 0-2.1-.6-2.3-.8-.9-1-1.1-2.7-1-3.3V18H9v7.2zM40 35c0 2.5-2.8 5-5.2 5H19.1c-2.4 0-5.1-2.5-5.1-5V5h26v30zm7.6-10.6c-.2.2-.8.8-2.3.8H45V18h3.6v3.1c0 .6-.1 2.4-1 3.3z" />
            <path d="M18 18.8v.2l8.6 6.7h.7l8.7-6.8v-4.6l-4.7-3.8-4.4 3.5-4.2-3.8-4.7 3.5z" />
        </g>
        <clipPath>
            <path d="M10.6 118.4l-4.4 4.4-4.4-4.4-1.1 1.1 4.4 4.4-4.4 4.4 1.1 1.1 4.4-4.4 4.4 4.4 1.1-1.1-4.4-4.4 4.4-4.4z" />
        </clipPath>
    </SeeYouAgainSVG>
);

const SpeedyResponseSVG = styled(Icon).attrs({ viewBox: '0 0 54 61.9' })`
    width: 0.8723747981em;
`;

export const SpeedyResponse = ({ color = pink, ...props }) => (
    <SpeedyResponseSVG
        data-test="icon-speedy-response"
        {...props}
    >
        <g fill={color}>
            <path d="M54 20.9V13h-9V0H9v13H0v7.9c0 .7 0 4.5 2.5 7.2 1.1 1.1 3 2.5 6.2 2.5H9V35c0 5.5 4.8 10 10.1 10H24v12h-9v4.9h23V57h-9V45h5.8C40.2 45 45 40.5 45 35v-4.4h.2c3.2 0 5.2-1.3 6.2-2.5 2.6-2.7 2.6-6.4 2.6-7.2zM9 25.2h-.2c-1.6 0-2.1-.6-2.3-.8-.9-1-1.1-2.7-1-3.3V18H9v7.2zM40 35c0 2.5-2.8 5-5.2 5H19.1c-2.4 0-5.1-2.5-5.1-5V5h26v30zm7.6-10.6c-.2.2-.8.8-2.3.8H45V18h3.6v3.1c0 .6-.1 2.4-1 3.3z" />
            <path d="M24 26.7h4.8l3.2-11h-3.3l1.3-6h-5l-3 11h3z" />
        </g>
        <clipPath>
            <path d="M-63.4 118.4l-4.4 4.4-4.4-4.4-1.1 1.1 4.4 4.4-4.4 4.4 1.1 1.1 4.4-4.4 4.4 4.4 1.1-1.1-4.4-4.4 4.4-4.4z" />
        </clipPath>
    </SpeedyResponseSVG>
);

export default {
    RapidRegistration,
    SchedulingHero,
    SeeYouAgain,
    SpeedyResponse,
};
